import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { ref, useContext, onMounted, computed, onUnmounted } from '@nuxtjs/composition-api'
// import { useCallWaiterModel } from '@entities/call-waiter'
import { ButtonClose } from '@shared/ui'
import { WaiterChat, useCallWaiterModel } from '@entities/call-waiter'
import { IItemsMess, IItems, IReq } from '@entities/call-waiter/model/types'
import { useThemeModel } from '@entities/theme'
import { useRestaurantModel } from '@entities/restaurant'
import { getCurrentDate, togglePageScroll } from '@shared/utils'
import { sendMessage as telegramSendMessage } from '@features/telegram'
import { useOrderModel } from '@entities/order'


export default /*#__PURE__*/_defineComponent({
  __name: 'CallWaiter',
  props: {
  tableCode: {
    type: String as PropType<string>,
    required: true,
    default: '0'
  }
},
  emits: ['toggleModal'],
  setup(__props, { emit }) {

const props = __props

const { $cookies } = useContext()

const callWaiterModel = useCallWaiterModel()
const themeModel = useThemeModel()
const restaurantModel = useRestaurantModel()
const orderModel = useOrderModel()
const guidanceRecipientRestaurantCodes = ['mrs-bakery-31658', 'mrs-bakery-two-31659']



// const callWaiterModel = useCallWaiterModel()



const quickPhrases = [
  'Подойдите',
  'Нужны приборы',
  'Принесите меню',
  'Принесите счет',
  'Уберите со стола'
]

const textarea = ref<HTMLTextAreaElement | undefined>()
const serverMessageOverride = ref<string | null>(null)
const waiterText = ref<string>('')
const callingWaiterText = ref<string>('')
const tableNumberText = ref<string>('')
const tableCodeText = ref<string>('')
const heigtScreen = ref<number>(0)
const msg = ref<string>('')
const repeatRequest = ref<boolean>(false)
const preloaderMessage = ref<boolean>(false)
const itemsMess = ref<IItemsMess[]>([])
const items = ref<IItems>({
  itemsTapper: [
    { content: 'Привет! Я отправлю официанту все, что Вы тут напишете' },
    {
      content: 'Я отправил сообщение официанту.\n\nТаппер создан для оплаты счёта и чаевых — оплатите в 1 клик не дожидаясь официанта.'
    },
    { content: 'Я отправил сообщение официанту!' },

    { content: 'Привет! Я отправлю менеджеру все, что Вы тут напишете' },
    { content: 'Я отправил сообщение менеджеру!' }
  ]
})

const maxCookieAge = 60 * 60 * 24 * 1
const isGuidanceRecipientRestaurant = () =>
  guidanceRecipientRestaurantCodes.includes(restaurantModel.code) &&
  orderModel.orderData?.recipient === 'MANAGER'
const managerGreetingLegacyText = 'Привет! Я отправлю менеджеру все, что Вы тут напишете'
const managerGreetingGuidanceText = 'Привет! Я отправлю руководству все, что Вы тут напишете'
const managerSentLegacyText = 'Я отправил сообщение менеджеру!'
const managerSentGuidanceText = 'Я отправил сообщение руководству!'
const invoiceWaiterLegacyText = 'Я отправил сообщение официанту.\n\nТаппер создан для оплаты счёта и чаевых — оплатите в 1 клик не дожидаясь официанта.'
const invoiceGuidanceText = 'Я отправил сообщение руководству.\n\nТаппер создан для оплаты счёта и чаевых — оплатите в 1 клик не дожидаясь официанта.'

/**
 * Сохраняем будущий бот-ответ в cookie сразу, чтобы не потерять историю
 * при закрытии модалки до окончания имитации набора (setTimeout).
 */
const persistBotMessage = (message: string) => {
  const nextMessage: IItemsMess = {
    id: itemsMess.value.length + 1,
    role: 'tapper',
    message
  }

  const nextHistory = [...itemsMess.value, nextMessage]
  $cookies.set('itemsMess', nextHistory, { maxAge: maxCookieAge })
  return nextMessage
}

const resize = () => {
  const element = textarea.value
  if (element) {
    element.style.height = '40px'
    element.style.height = element.scrollHeight + 'px'
  }
}

const onGreeting = () => {
  preloaderMessage.value = true
  if (orderModel.orderData && orderModel.orderData.recipient === 'MANAGER') {
    managerGreeting()
  } else {
    waiterGreeting()
  }
}

const scrollDown = () => {
  setTimeout(() => {
    const waiterChatEl = document.querySelector('.waiterChat')
    if (waiterChatEl) {
      waiterChatEl.scrollTo(0, waiterChatEl.scrollHeight)
    }
  }, 100)
}

const sendingUserMessage = () => {
  itemsMess.value.push({
    id: itemsMess.value.length + 1,
    role: 'user',
    message: msg.value
  })
  $cookies.set('itemsMess', itemsMess.value, {
    maxAge: 60 * 60 * 24 * 1
  })
  scrollDown()
}

const necessityGreeting = () => {
  const dialogArray = $cookies.get('itemsMess')
  if (dialogArray != null) {
    if (isGuidanceRecipientRestaurant()) {
      itemsMess.value = dialogArray.map((item: IItemsMess) => (
        item.message === managerGreetingLegacyText
          ? { ...item, message: managerGreetingGuidanceText }
          : item.message === managerSentLegacyText
            ? { ...item, message: managerSentGuidanceText }
            : item.message === invoiceWaiterLegacyText
              ? { ...item, message: invoiceGuidanceText }
              : item
      ))
      $cookies.set('itemsMess', itemsMess.value, { maxAge: maxCookieAge })
    } else {
      itemsMess.value = dialogArray
    }
  } else {
    onGreeting()
  }
  scrollDown()
}

const sendingMessageWaiter = () => {
  const nextMessage = persistBotMessage(items.value.itemsTapper[2].content)
  setTimeout(() => {
    preloaderMessage.value = false
    itemsMess.value.push(nextMessage)
    $cookies.set('itemsMess', itemsMess.value, { maxAge: maxCookieAge })
    scrollDown()
  }, 1000)
}

const sendingMessageManager = () => {
  const managerSentText = isGuidanceRecipientRestaurant()
    ? managerSentGuidanceText
    : items.value.itemsTapper[4].content
  const nextMessage = persistBotMessage(managerSentText)
  setTimeout(() => {
    preloaderMessage.value = false
    itemsMess.value.push(nextMessage)
    $cookies.set('itemsMess', itemsMess.value, { maxAge: maxCookieAge })
    scrollDown()
  }, 1000)
}

const responseRequestExpense = () => {
  const invoiceResponseText = isGuidanceRecipientRestaurant()
    ? invoiceGuidanceText
    : items.value.itemsTapper[1].content
  const nextMessage = persistBotMessage(invoiceResponseText)
  setTimeout(() => {
    preloaderMessage.value = false
    itemsMess.value.push(nextMessage)
    $cookies.set('itemsMess', itemsMess.value, { maxAge: maxCookieAge })
    scrollDown()
  }, 1000)
}

const managerGreeting = () => {
  const managerGreetingText = isGuidanceRecipientRestaurant()
    ? managerGreetingGuidanceText
    : items.value.itemsTapper[3].content
  const nextMessage = persistBotMessage(managerGreetingText)
  setTimeout(() => {
    preloaderMessage.value = false
    itemsMess.value.push(nextMessage)
    $cookies.set('itemsMess', itemsMess.value, { maxAge: maxCookieAge })
  }, 1000)
}

const waiterGreeting = () => {
  const nextMessage = persistBotMessage(items.value.itemsTapper[0].content)
  setTimeout(() => {
    preloaderMessage.value = false
    itemsMess.value.push(nextMessage)
    $cookies.set('itemsMess', itemsMess.value, { maxAge: maxCookieAge })
  }, 1000)
}

const toggleModal = () => {
  emit('toggleModal')
  msg.value = ''
}

const waiterName = () => {
  if (orderModel.orderData && orderModel.orderData.waiter) {
    if (orderModel.orderData.waiter.waiter_status !== 'VERIFIED') {
      return 'Неизвестный официант'
    }
    return orderModel.orderData.waiter.display_name || orderModel.orderData.waiter.name
  }
  return 'Неизвестный официант'
}

const sendMessage = () => {
  !orderModel.orderData || !orderModel.orderData?.waiter || !orderModel.orderData?.waiter?.hasTelegram ? callingWaiterText.value = '*!! Вызов официанта !!*' : callingWaiterText.value = '🖐 Вызов официанта'
  !orderModel.orderData || !orderModel.orderData?.waiter || !orderModel.orderData?.waiter?.hasTelegram ? tableNumberText.value = '*🖐 Номер столика: *' : tableNumberText.value = 'Номер столика: '
  !orderModel.orderData || !orderModel.orderData?.waiter || !orderModel.orderData?.waiter?.hasTelegram ? tableCodeText.value = '*' + props.tableCode + '*' : tableCodeText.value = props.tableCode
  orderModel.orderData?.waiter?.waiter_status === 'VERIFIED' ? waiterText.value = '\n' + 'Официант: ' + waiterName() : waiterText.value = ''

  const comment = serverMessageOverride.value ?? msg.value

  const newMsg =
      callingWaiterText.value +
    '\n' +
    tableNumberText.value +
    tableCodeText.value +
    waiterText.value +
    '\n' +
    'Комментарий: ' +
    comment +
    '\n' +
    'Время: ' +
    getCurrentDate()
  msg.value = ''
  serverMessageOverride.value = null

  const req: IReq = {
    shopCode: restaurantModel.code,
    message: newMsg,
    messageType: 'WAITER_CALL',
    sessionId: orderModel.orderData?.session ? parseInt(orderModel.orderData.session) : null
  }

  if (
    orderModel.orderData &&
    orderModel.orderData.waiter &&
    orderModel.orderData.waiter.user &&
    orderModel.orderData.waiter.user.id
  ) {
    req.userId = orderModel.orderData.waiter.user.id
  }
  telegramSendMessage(req)
}

const dispatchMessage = () => {
  if (msg.value.length && orderModel.orderData && orderModel.orderData.recipient !== 'MANAGER') {
    preloaderMessage.value = true
    sendingUserMessage()

    const invoiceRequest1 = msg.value.toLowerCase().includes('счет')
    const invoiceRequest2 = msg.value.toLowerCase().includes('счёт')

    if (invoiceRequest1 || invoiceRequest2) {
      if (!repeatRequest.value) {
        responseRequestExpense()
        repeatRequest.value = true
      } else {
        sendingMessageWaiter()
      }
    } else {
      sendingMessageWaiter()
    }
  } else {
    preloaderMessage.value = true
    sendingUserMessage()
    scrollDown()

    const invoiceRequest1 = msg.value.toLowerCase().includes('счет')
    const invoiceRequest2 = msg.value.toLowerCase().includes('счёт')

    if (invoiceRequest1 || invoiceRequest2) {
      if (!repeatRequest.value) {
        responseRequestExpense()
        repeatRequest.value = true
      } else {
        sendingMessageManager()
      }
    } else {
      sendingMessageManager()
    }
    scrollDown()
    sendMessage()
    msg.value = ''
  }
  const element = textarea.value
  if (element) {
    element.style.height = '40px'
  }
}

const CallWaiterSendImage = computed(() =>
  themeModel.theme.toLowerCase() === 'novikov' ? require('~/assets/img/dispatchNovikov.svg') : require('~/assets/img/dispatch.svg')
)

const sendQuickMessage = (phrase: string) => {
  // Для кнопки "Подойдите" показываем пользователю одну фразу, а на сервер отправляем другую
  if (phrase === 'Подойдите') {
    msg.value = 'Подойдите, пожалуйста'
    serverMessageOverride.value = 'Гость просит подойти'
  } else if (phrase === 'Уберите со стола') {
    msg.value = phrase
    serverMessageOverride.value = 'нужно убрать со стола'
  } else {
    msg.value = phrase
    serverMessageOverride.value = null
  }

  // Менеджерский поток уже вызывает sendMessage внутри dispatchMessage
  if (orderModel.orderData && orderModel.orderData.recipient === 'MANAGER') {
    dispatchMessage()
    return
  }

  // Официантский поток: сначала обновляем UI, затем отправляем
  dispatchMessage()
  sendMessage()
}

onMounted(() => {
  callWaiterModel.modalScrollWaiter = true
  heigtScreen.value = document.documentElement.clientHeight / 2
  togglePageScroll(true)
  necessityGreeting()
  resize()
})

onUnmounted(() => {
  callWaiterModel.modalScrollWaiter = false
})

return { __sfc: true,$cookies, callWaiterModel, themeModel, restaurantModel, orderModel, guidanceRecipientRestaurantCodes, emit, props, quickPhrases, textarea, serverMessageOverride, waiterText, callingWaiterText, tableNumberText, tableCodeText, heigtScreen, msg, repeatRequest, preloaderMessage, itemsMess, items, maxCookieAge, isGuidanceRecipientRestaurant, managerGreetingLegacyText, managerGreetingGuidanceText, managerSentLegacyText, managerSentGuidanceText, invoiceWaiterLegacyText, invoiceGuidanceText, persistBotMessage, resize, onGreeting, scrollDown, sendingUserMessage, necessityGreeting, sendingMessageWaiter, sendingMessageManager, responseRequestExpense, managerGreeting, waiterGreeting, toggleModal, waiterName, sendMessage, dispatchMessage, CallWaiterSendImage, sendQuickMessage, ButtonClose, WaiterChat }
}

})